import React from 'react'
import RenderDelay from './../render_delay/RenderDelay'

const SuspenseLoader = () => {
    return (
        <RenderDelay>
            <div className="loader_dots" />
        </RenderDelay>
    )
}

export default SuspenseLoader
